<ng-template #loading>
    <app-mat-spinner-overlay text="Vent litt..."></app-mat-spinner-overlay>
</ng-template>

<h2 *ngIf="!isInvalid">{{getLabelValue('Title') | striphtml}}</h2>
<h2 *ngIf="isInvalid">Ingen tilgang</h2>

<div class="flex-column flex-gap-20" *ngIf="data; else loading">

    <p *ngIf="!isInvalid" [innerHtml]="getLabelValue('TitleDescription') | safe: 'html'"></p>

    <p *ngIf="isInvalid">
        Beklager, det oppsto en feil. <span class="click" (click)="logout()">Trykk her for å logge ut</span>
    </p>

    <form [formGroup]="approveContactForm" novalidate *ngIf="!isInvalid">

        <div class="flex-grow flex-column flex-gap-20">

            <mat-radio-group *ngIf="!contactInvitationApproved?.IsBank" class="flex-column" formControlName="RecipientType">
                <mat-radio-button [value]="0">Jeg er privatperson</mat-radio-button>
                <mat-radio-button *ngIf="contactInvitationType === 0" [value]="1">Jeg er advokat/rettshjelper</mat-radio-button>
                <mat-radio-button *ngIf="contactInvitationType === 1" [value]="1">Jeg representerer et firma</mat-radio-button>
            </mat-radio-group>

            <div class="flex-column flex-gap-20">
                <div class="flex-column flex-gap-10">

                    <div class="form-label" *ngIf="approveContactForm.controls.RecipientType.value === 0">Personlig informasjon</div>

                    <div class="flex-row" *ngIf="approveContactForm.controls.RecipientType.value === 1">
                        <app-orgnum-form-control class="flex-half" [companyInfo]="companyInfo"
                            (companyInfoReceived)="companyInfoReceived($event)" formControlName="OrgNumber">
                        </app-orgnum-form-control>
                    </div>

                    <div class="flex-row flex-gap-20">
                        <!-- fornavn, etternavn-->
                        <mat-form-field class="flex-half flex-grow">
                            <mat-label *ngIf="approveContactForm.controls.RecipientType.value === 0">Fornavn</mat-label>
                            <mat-label *ngIf="approveContactForm.controls.RecipientType.value === 1">Firma</mat-label>
                            <input matInput formControlName="FirstName" autocomplete="given-name">
                            <mat-error *ngIf="approveContactForm.controls?.FirstName?.errors?.required">
                                {{approveContactForm.controls.RecipientType.value === 0 ? 'Fornavn' : 'Firma'}} er et
                                obligatorisk
                                felt</mat-error>
                            <mat-error *ngIf="approveContactForm.controls?.FirstName?.errors?.maxlength">
                                {{approveContactForm.controls.RecipientType.value === 0 ? 'Fornavn' : 'Firma'}} kan maksimalt
                                inneholde
                                {{approveContactForm.controls.FirstName.errors?.maxlength.requiredLength}}
                                tegn</mat-error>
                        </mat-form-field>

                        <mat-form-field class="flex-half flex-grow">
                            <mat-label *ngIf="approveContactForm.controls.RecipientType.value === 0">Etternavn</mat-label>
                            <mat-label *ngIf="approveContactForm.controls.RecipientType.value === 1">Att</mat-label>

                            <input matInput formControlName="LastName" autocomplete="family-name">
                            <mat-error *ngIf="approveContactForm.controls?.LastName?.errors?.required">
                                {{approveContactForm.controls.RecipientType.value === 0 ? 'Etternavn' : 'Att'}} er et
                                obligatorisk
                                felt</mat-error>
                            <mat-error *ngIf="approveContactForm.controls?.LastName?.errors?.maxlength">
                                {{approveContactForm.controls.RecipientType.value === 0 ? 'Etternavn' : 'Att'}} kan maksimalt
                                inneholde {{approveContactForm.controls.LastName.errors?.maxlength.requiredLength}}
                                tegn</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="flex-row flex-gap-20">

                    <div class="flex-column flex-half flex-gap-10">
                        <div class="form-label">Adresse</div>

                        <mat-form-field class="flex-grow"
                            *ngIf="approveContactForm?.controls?.CountryCodeAlpha2?.value === 'NO'">
                            <mat-label>Adresse</mat-label> <!-- husk alternative label her -->
                            <input matInput formControlName="Address" autocomplete="street-address">
                            <mat-error
                                *ngIf="approveContactForm?.controls?.Address?.errors && approveContactForm?.controls?.Address?.errors?.required">Adresse
                                er et obligatorisk felt</mat-error>
                            <mat-error
                                *ngIf="approveContactForm?.controls?.Address?.errors && approveContactForm?.controls?.Address?.errors?.maxlength">Adresse
                                kan maksimalt inneholde
                                {{approveContactForm.controls.Address.errors?.maxlength.requiredLength}}
                                tegn</mat-error>
                        </mat-form-field>

                        <mat-form-field class="flex-grow"
                            *ngIf="approveContactForm?.controls?.CountryCodeAlpha2?.value !== 'NO'">
                            <mat-label>Utenlandsk adresse</mat-label>
                            <textarea style="height:107px;" matInput formControlName="Address"></textarea>
                            <mat-error
                                *ngIf="approveContactForm?.controls?.Address?.errors && approveContactForm?.controls?.Address?.errors?.required">Adresse
                                er et obligatorisk felt</mat-error>
                            <mat-error
                                *ngIf="approveContactForm?.controls?.Address?.errors && approveContactForm?.controls?.Address?.errors?.maxlength">Adresse
                                kan maksimalt inneholde
                                {{approveContactForm.controls.Address.errors?.maxlength.requiredLength}}
                                tegn</mat-error>
                        </mat-form-field>

                        <div class="flex-row flex-gap-10"
                            *ngIf="approveContactForm?.controls?.CountryCodeAlpha2?.value === 'NO'">
                            <mat-form-field style="flex: 0 1 100px">
                                <mat-label>Postnr</mat-label> <!-- husk alternative label her -->
                                <input matInput formControlName="PostalCode" autocomplete="postal-code">
                                <mat-error>Postnr er et obligatorisk felt</mat-error>
                            </mat-form-field>

                            <mat-form-field class="flex-grow">
                                <mat-label>Poststed</mat-label> <!-- husk alternative label her -->
                                <input matInput formControlName="PostalPlace">
                                <mat-error>Poststed er et obligatorisk felt</mat-error>
                            </mat-form-field>
                        </div>

                        <mat-form-field class="flex-grow">
                            <mat-label>Land</mat-label>
                            <mat-select formControlName="CountryCodeAlpha2">
                                <mat-option *ngFor="let countryCode of filteredCountries | async"
                                    [value]="countryCode.cca2">
                                    {{countryCode.name.common}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="flex-column flex-half flex-gap-10">
                        <div class="form-label">Kontaktinformasjon</div>

                        <!-- E-post -->
                        <mat-form-field class="flex-grow">
                            <mat-label>E-post</mat-label>
                            <input matInput placeholder="E-post" formControlName="Email" autocomplete="email">
                            <mat-error
                                *ngIf="approveContactForm.controls.Email.errors && approveContactForm.controls?.Email?.errors?.required">
                                E-post er et obligatorisk felt</mat-error>
                            <mat-error *ngIf="approveContactForm.controls?.Email?.errors?.maxlength">E-post kan
                                maksimalt
                                inneholde
                                {{approveContactForm.controls.Email.errors?.maxlength.requiredLength}} tegn</mat-error>
                            <mat-error
                                *ngIf="approveContactForm.controls.Email.errors && approveContactForm.controls?.Email?.errors?.email">
                                Ugyldig e-postadresse</mat-error>
                            <mat-error
                                *ngIf="approveContactForm.controls?.Email?.errors && approveContactForm.controls?.Email?.errors?.invalidCompareEmail">
                                E-post og bekreft e-post er ikke like</mat-error>

                        </mat-form-field>

                        <!-- Telefon -->
                        <div class="flex-column flex-gap-5">
                            <div class="flex-row flex-gap-10">
                                <mat-form-field style="flex: 0 1 130px" subscriptSizing="dynamic">
                                    <mat-select formControlName="PhoneCountryCode">
                                        <mat-select-trigger>
                                            {{getPhoneDisplayValueFromCountryCode(approveContactForm.controls.PhoneCountryCode.value,
                                            false)}}
                                        </mat-select-trigger>
                                        <mat-option *ngFor="let country of filteredCountries | async"
                                            [value]="country.cca2">
                                            {{getPhoneDisplayValueFromCountryCode(country.cca2, true)}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="flex-grow" subscriptSizing="dynamic">
                                    <mat-label>Telefon/mobil</mat-label>
                                    <input matInput placeholder="Telefon/mobil" formControlName="Phone"
                                        autocomplete="tel">
                                </mat-form-field>
                            </div>
                            <div class="error-text-wrapper">
                                <mat-error
                                    *ngIf="approveContactForm.dirty && approveContactForm.controls.Phone?.errors?.required">
                                    Telefonnummer er et obligatorisk felt
                                </mat-error>
                                <mat-error
                                    *ngIf="approveContactForm.dirty && approveContactForm.controls.Phone?.errors?.phoneFormatError">
                                    Ugyldig telefonnummer
                                </mat-error>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="flex-row flex-gap-20">
                    <button style="flex: 0 1 150px" type="button" class="finkn-btn" color="primary" mat-raised-button
                        (click)="save()">Bekreft</button>
                    <button style="flex: 0 1 150px" type="button" class="finkn-btn" color="primary" mat-raised-button
                        (click)="cancel()">Avbryt</button>
                </div>
            </div>
        </div>
    </form>

</div>